import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import validator from 'validator';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import i18nInstance from '@moka-bo/i18n';
import Captcha from './Captcha';
import AuthField from '../Fields/AuthField';

const validate = values => {
  const errors = {};
  if (!values.email) {
    errors.email = i18nInstance._(t`The email address is required`);
  } else if (!validator.isEmail(values.email)) {
    errors.email = i18nInstance._(t`Please enter a valid email address`);
  }
  if (!values.captcha) {
    errors.captcha = i18nInstance._(t`The captcha is not valid`);
  }
  return errors;
};

class ResendVerificationEmailForm extends React.Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <I18n>
          {({ i18n }) => (
            <Field
              component={AuthField}
              name="email"
              type="text"
              placeholder={i18n._(t`Email`)}
              autoCorrect="off"
              autoCapitalize="off"
              icon="fa fa-envelope-o"
              spellCheck="false"
            />
          )}
        </I18n>
        <Field component={Captcha} name="captcha" />
        <button type="submit" className="btn btn-primary btn-block">
          <Trans>Resend</Trans>
        </button>
      </form>
    );
  }
}

ResendVerificationEmailForm.propTypes = {
  handleSubmit: PropTypes.func,
};

export default reduxForm({
  form: 'resendVerificationEmail',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
})(ResendVerificationEmailForm);
